<template>
    <div class="story-maker-sticker-menu-post">
        <div class="header-menu">
            <p>{{ $t('dash.post-creator.story.post-title') }}</p>
        </div>
        <div class="content">
            
            <div class="form">
                <div class="container-input">
                    <div class="input input-link">
                        <i class="fa-regular fa-link"></i>
                        <input :placeholder="$t('dash.post-creator.story.url-placeholder')" v-model="models.link">
                    </div>
                    <p class="error">{{ error }}</p>
                </div>
                

            </div>
           
            <div class="button" @click="finish">
                <template v-if="isLoading">
                    <i class="fa-sharp fa-solid fa-spinner-third"></i>
                </template>
                <template v-else>
                   {{ $t('dash.post-creator.story.add-button') }}
                </template>
                
            </div>
        </div>
        
    </div>
</template>


<script>
import store from '@/store/index.js';
import { EventBus } from '@/event-bus';
import BotMixin from '@/components/mixins/Bots.vue'
export default {
    mixins: [BotMixin],
    data() {
        return {
            models: {
                link : '',
            },
            error : '',
            isLoading: false,
        }
    },
    
    methods: {
        async finish () {      
            if (this.isLoading) return
            this.isLoading = true
            
            this.error = ''      
            console.log('validURL', this.models.link, this.validURL(this.models.link))
            if (!this.validURL(this.models.link)){
                this.error = 'adresse invalide'
            }else{
                let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                
                if (page) {
                    const res = await this.getInfoInstagram({url: encodeURI(this.models.link), id: page.id })
                
                    console.log('res', res)
                    const {isReel, isCarousel, description, image, video, username, avatar, info} = res.body

                    const infoParts = info ? info.split(':') : []
                    const data = {
                        url: null,
                        width: image.width,
                        height: image.height,
                        type: null,
                        fileType: null,
                        typePost: isCarousel ? 'carousel' : isReel ? 'reel' : 'simple',
                        styleVariant: 1,
                        textContent: description,
                        pageName: username,
                        avatar: avatar,
                        owner_user_id: infoParts[1] || null,
                        media_id: infoParts[2] || null,
                    }

                    if (['reel', 'carousel'].includes(data.typePost) && video) {
                        data.url = video.url
                        data.type = 'video'
                        data.fileType = 'video/mp4'
                        data.width = video.width
                        data.height = video.height
                    } else {
                        data.url = image.url
                        data.type = 'image'
                        data.fileType = 'image/jpeg'
                        data.width = image.width,
                        data.height = image.height
                    }

                    this.$emit('addSticker','post', {
                        data: data,
                        disableDelete: false
                    })
                }
            
              
            }
            this.isLoading = false
        },

        validURL(str) {
            if(str == '') return false
            str = str.replace('/reel/','/p/')
            try {
                return /https:\/\/www\.instagram\.com\/p\/[a-zA-Z0-9_-]{11}\/.*/.test(str); 
            }
            catch(e){ 
                return false; 
            }
        },
    },
       computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
       }
}
</script>

<style lang="scss" scoped>

</style>